<template>
  <div>
<!--todo do navigation with only the tasks and special task -->
    <v-app-bar
      app
      color="primary"
      dark
      shrink-on-scroll
      prominent
      src="/kim_splash_web.jpg"
      fade-img-on-scroll
      scroll-threshold="150"
    >
      <template v-slot:img="{ props }">
        <v-img v-bind="props" gradient="to top right, rgba(212,8,44,.6), rgba(148,8,37,.6)"></v-img>
      </template>

      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title>
        <v-img
          alt="Vuetify Logo"
          class="shrink mt-2"
          contain
          src="/header_logo.png"
          transition="scale-transition"
          width="85"
        />
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <template v-slot:extension>
        <v-tabs align-with-title v-model="activeTab">
          <v-tab
            v-for="tab in tabData"
            :key="tab.index"
            @click="navigate({ name: tab.route })">
            <v-icon v-if="tab.icon">{{tab.icon}}</v-icon>
            <span v-if="tab.icon" class="d-none d-sm-flex">&nbsp;</span><span class="d-none d-sm-flex">{{$i18n.t(tab.title)}}</span></v-tab>
        </v-tabs>
      </template>
    </v-app-bar>

    <v-navigation-drawer app v-model="drawer" width="400">
      <v-list-item class="py-2">
        <v-list-item-avatar>
          <v-icon class="grey lighten-1 white--text">mdi-account</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>{{candidate.firstName}} {{candidate.lastName}}</v-list-item-title>
        </v-list-item-content>
        <v-icon class="primary--text" @click="showConfirmLogout=true">mdi-logout</v-icon>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <v-list>
          <template v-for='exercise in exercises'>
            <v-list-item
              :class='{ isHighlighted: exercise.id === currentExerciseId}'
              link
              :key='`ex_${candidate.id}_${exercise.id}`'
              v-if='exercise'
              @click='setExercise(exercise.id)'>
              <v-list-item-icon>
                <v-icon :color='getStatus(exercise.id)'>mdi-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-title>
                {{ exercise.name }}
              </v-list-item-title>
            </v-list-item>
          </template>
        </v-list>
      </v-list>
    </v-navigation-drawer>

    <!-- Modal -->
    <v-dialog class="logout-confirm-dialog" v-model="showConfirmLogout" width="400">
      <v-card>
        <v-card-title class="headline">{{$t('ConfirmLogoutDialog.title')}}</v-card-title>
        <v-card-text v-html="$t('ConfirmLogoutDialog.description')" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showConfirmLogout=false">{{$t('ConfirmLogoutDialog.no')}}</v-btn>
          <v-btn color="primary" text @click="confirmedLogout()">{{$t('ConfirmLogoutDialog.yes')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import LoadingState from '@/api/LoadingState';
import BusinessLogicOverview from '@/libs/businessLogicOverview';
import BusinessLogicExercise from '@/libs/BusinessLogicExercise';

export default {
  // eslint-disable vue/multi-word-component-names
  name: 'Navigation',
  props: ['mobile'],
  data: () => ({
    drawer: null,
    showConfirmLogout: false,
    tabData: [
      {
        index: 0,
        route: 'overview',
        title: 'Navigation.menuItemOverview',
        icon: 'mdi-format-list-checks',
      },
      {
        index: 1,
        route: 'notes',
        title: 'Navigation.menuItemNotes',
        icon: 'mdi-clipboard-text-multiple-outline',
      },
      {
        index: 2,
        route: 'timetable',
        title: 'Navigation.menuItemTimeTable',
        icon: 'mdi-timetable'
      },
      {
        index: 3,
        route: 'manual',
        title: 'Navigation.menuItemManual',
        icon: 'mdi-book-open-page-variant',
      },
    ],
    activeTab: 0,
    collapsedMenu: {
      candidateGroup_0: true,
    },
  }),
  computed: {
    ...mapState({
      currentExerciseId: (state) => state.run.currentExerciseId,
      timeTable: (state) => state.run.timeTable,
      candidate: (state) => state.run.candidate,
      exercises: (state) => state.run.exercises,
      openExerciseId: (state) => state.run.candidate.selectedExerciseId,
      loading: (state) => state.run.loadingState.runInfo === LoadingState.LOADING,
      loaded: (state) => state.run.loadingState.runInfo === LoadingState.LOADED
    }),
    ...mapGetters(['isExerciseBlocked'])
  },
  methods: {
    setExercise(exerciseId) {
      const logic = new BusinessLogicOverview(this);
      logic.setExercise(exerciseId)
    },
    getStatus(exerciseId) {
      return new BusinessLogicExercise(this).getExerciseOpenStatus(exerciseId);
    },
    confirmedLogout() {
      this.$store.commit('clearState');
      this.$router.push('/login');
    },
    setActiveTabFromRoute() {
      const filtered = this.tabData.find((tab) => tab.route === this.$route.name);
      const fIndex = filtered?.index;
      this.activeTab = fIndex || null;
    },
    navigate(route) {
      if (route.name !== this.$route.name) {
        this.$router.push(route);
      }
    },
  },
  watch: {
    $route() {
      const self = this;
      self.setActiveTabFromRoute();
    }
  },
  mounted() {
    this.setActiveTabFromRoute();
    if (!this.loading && !this.loaded) this.$api.run.get('candidate')

    const self = this;
    // there has to be a better solution than fucky event bus
    // EventBus.$on(EVENTS.ROUTE_PUSHED, () => {
    //   self.setActiveTabFromRoute();
    // });
  },
};
</script>

<style scoped lang="scss">
  @import '@/ci.scss';

  .isHighlighted {
    background-color: $highlighted;
  }

  .icon-spin {
    -webkit-animation: spin 1500ms infinite linear;
    animation: spin 1500ms infinite linear;
  }
  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(-359deg);
      transform: rotate(-359deg);
    }
  }
  @keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(-359deg);
      transform: rotate(-359deg);
    }
  }

</style>
